<div class="flex flex-col space-y-4 pt-8" [formGroup]="uploadForm">
  <div class="flex flex-row items-center justify-center lg:basis-1/3">
    <ng-container *ngIf="uploadForm.value.file; else selectFile">
      <p>
        Uploading: {{ uploadForm.value.file.name }} ({{
          uploadForm.value.file.size | filesize
        }})
      </p>
    </ng-container>
    <ng-template #selectFile>
      <input
        type="file"
        class="hidden"
        id="file"
        (change)="handleFileInput($event.target)"
      />
      <label
        for="file"
        class="mdc-button mdc-button--raised mat-mdc-raised-button mat-unthemed mat-mdc-button-base cursor-pointer flex flex-row items-center justify-center space-x-4"
      >
        <mat-icon>upload</mat-icon>
        <p>Upload new attachment</p>
      </label>
    </ng-template>
  </div>
  <ng-container *ngIf="uploadForm.value.file; else listFiles">
    <mat-form-field>
      <mat-label>Description</mat-label>
      <input matInput formControlName="description" placeholder="Description" />
    </mat-form-field>
    <div class="flex flex-row justify-center items-center">
      <button mat-flat-button (click)="uploadForm.patchValue({ file: null })">
        Cancel
      </button>
      <button
        mat-flat-button
        color="primary"
        (click)="addAttachment()"
        [disabled]="uploadForm.invalid"
      >
        Upload
      </button>
    </div>
  </ng-container>
  <ng-template #listFiles>
    <ng-container *ngIf="showList$ | async; else noFiles">
      <div
        class="flex flex-row items-start justify-start w-full"
        *ngFor="let attachment of attachments$ | async"
      >
        <div class="flex flex-col basis-full">
          <p>{{ attachment.description }} - {{ attachment.file_name }}</p>
          <p>
            <small
              >{{ attachment.size | filesize }} | Uploaded by
              {{ attachment.uploaded_by | userIdToName | async }} on
              {{ attachment.created_at | amDateFormat : dateFormat }}</small
            >
          </p>
        </div>
        <div
          class="flex flex-row flex-grow-0 items-start justify-center space-x-4"
        >
          <a
            mat-icon-button
            [href]="attachment.url"
            [download]="attachment.file_name"
            target="_blank"
          >
            <mat-icon>download</mat-icon>
          </a>
          <button mat-icon-button (click)="deleteAttachment(attachment.id)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </ng-container>
    <ng-template #noFiles>
      <p class="py-20 text-center"><em>This item has no attachments</em></p>
    </ng-template>
  </ng-template>
</div>
